import { SvgIcon } from "@mui/material";

export default function TobuyNotificationIcon({
  width = "20px",
  height = "20px",
}) {
  return (
    <SvgIcon
      sx={{ width: width, height: height }}
      viewBox="0 0 20 20"
      fill={"none"}
    >
      <g clipPath="url(#clip0_1588_7445)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.79167 2.41669V4.38199C6.79167 5.04745 6.41205 5.65335 5.82152 5.94862C5.3957 6.16153 5.125 6.59857 5.125 7.06942V7.91669H3.625V7.06942C3.625 6.02519 4.22139 5.07163 5.1507 4.60698C5.23774 4.56346 5.29167 4.47407 5.29167 4.38199V2.16669C5.29167 1.47633 5.85131 0.916687 6.54167 0.916687H8.04167C8.73202 0.916687 9.29167 1.47633 9.29167 2.16669V4.38199C9.29167 4.47407 9.34559 4.56346 9.43263 4.60698C10.3619 5.07163 10.9583 6.02519 10.9583 7.06942V7.91669H9.45833V7.06942C9.45833 6.59857 9.18763 6.16153 8.76181 5.94862C8.17128 5.65335 7.79167 5.04745 7.79167 4.38199V2.41669H6.79167ZM12.2083 2.41669V4.16669H10.7083V2.16669C10.7083 1.47633 11.268 0.916687 11.9583 0.916687H13.4583C14.1487 0.916687 14.7083 1.47633 14.7083 2.16669V4.38199C14.7083 4.47407 14.7623 4.56346 14.8493 4.60698C15.7786 5.07163 16.375 6.02519 16.375 7.06942V7.91669H14.875V7.06942C14.875 6.59857 14.6043 6.16153 14.1785 5.94862C13.5879 5.65335 13.2083 5.04745 13.2083 4.38199V2.41669H12.2083ZM3.5 8.41669C2.5335 8.41669 1.75 9.20019 1.75 10.1667V12.5H3.25V10.1667C3.25 10.0286 3.36193 9.91669 3.5 9.91669H16.5C16.6381 9.91669 16.75 10.0286 16.75 10.1667V12.5H18.25V10.1667C18.25 9.20019 17.4665 8.41669 16.5 8.41669H3.5ZM3.25 15V17.3334C3.25 17.4714 3.36193 17.5834 3.5 17.5834H16.5C16.6381 17.5834 16.75 17.4714 16.75 17.3334V15H18.25V17.3334C18.25 18.2999 17.4665 19.0834 16.5 19.0834H3.5C2.5335 19.0834 1.75 18.2999 1.75 17.3334V15H3.25ZM4.16667 14.5H15.8333V13H4.16667V14.5ZM5.83333 11.6667C5.83333 12.1269 5.46024 12.5 5 12.5C4.53976 12.5 4.16667 12.1269 4.16667 11.6667C4.16667 11.2064 4.53976 10.8334 5 10.8334C5.46024 10.8334 5.83333 11.2064 5.83333 11.6667ZM15 12.5C15.4602 12.5 15.8333 12.1269 15.8333 11.6667C15.8333 11.2064 15.4602 10.8334 15 10.8334C14.5398 10.8334 14.1667 11.2064 14.1667 11.6667C14.1667 12.1269 14.5398 12.5 15 12.5ZM5.83333 15.8334C5.83333 16.2936 5.46024 16.6667 5 16.6667C4.53976 16.6667 4.16667 16.2936 4.16667 15.8334C4.16667 15.3731 4.53976 15 5 15C5.46024 15 5.83333 15.3731 5.83333 15.8334ZM15 16.6667C15.4602 16.6667 15.8333 16.2936 15.8333 15.8334C15.8333 15.3731 15.4602 15 15 15C14.5398 15 14.1667 15.3731 14.1667 15.8334C14.1667 16.2936 14.5398 16.6667 15 16.6667Z"
          fill="white"
        />
        <ellipse
          cx="14.9999"
          cy="4.99998"
          rx="4.16667"
          ry="4.16667"
          fill="#877564"
        />
        <ellipse
          cx="14.9998"
          cy="4.99996"
          rx="0.833333"
          ry="0.833333"
          fill="white"
        />
        <ellipse
          cx="12.4998"
          cy="4.99996"
          rx="0.833333"
          ry="0.833333"
          fill="white"
        />
        <ellipse
          cx="17.4998"
          cy="4.99996"
          rx="0.833334"
          ry="0.833333"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1588_7445">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
